import { render, staticRenderFns } from "./FacadeBox.vue?vue&type=template&id=2dd321b8&scoped=true"
import script from "./FacadeBox.vue?vue&type=script&lang=js"
export * from "./FacadeBox.vue?vue&type=script&lang=js"
import style0 from "./FacadeBox.vue?vue&type=style&index=0&id=2dd321b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd321b8",
  null
  
)

export default component.exports